module.exports = __webpack_public_path__ + "assets/animatecss.2bdd4623.svg";